import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { clearUser } from '../store/user/user.actions';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthCleanupService {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  /**
   * Effectue un nettoyage complet de la session
   */
  public cleanupSession(): void {
    console.log('Performing complete session cleanup');

    // 1. Dispatch l'action pour nettoyer le store
    this.store.dispatch(clearUser());

    // 2. Nettoyer le localStorage
    this.cleanLocalStorage();

    // 3. Nettoyer les cookies
    this.clearAuthCookies();

    // 4. Nettoyer sessionStorage
    this.cleanSessionStorage();

    console.log('Session cleanup completed');
  }

  /**
   * Nettoie le localStorage des données liées à l'authentification
   */
  public cleanLocalStorage(): void {
    console.log('Cleaning localStorage');

    // Supprimer les données utilisateur
    localStorage.removeItem('user');

    // Supprimer les tokens OIDC
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token');

    // Supprimer les clés de angular-auth-oidc-client (préfixées par '0-' ou 'oidc.')
    // et toute clé contenant 'token' ou 'auth'
    Object.keys(localStorage).forEach(key => {
      if (
        key.startsWith('oidc.') ||
        key.startsWith('0-') ||
        key.includes('token') ||
        key.includes('auth') ||
        key.includes('authnResult') ||
        key.includes('authWellKnownEndPoints') ||
        key.includes('userData') ||
        key.includes('authStateControl') ||
        key.includes('storageSilentRenewRunning')
      ) {
        console.log('Removing from localStorage:', key);
        localStorage.removeItem(key);
      }
    });
  }

  /**
   * Nettoie le sessionStorage des données liées à l'authentification
   */
  public cleanSessionStorage(): void {
    console.log('Cleaning sessionStorage');

    // Supprimer toutes les clés liées à angular-auth-oidc-client et l'authentification
    Object.keys(sessionStorage).forEach(key => {
      if (
        key.startsWith('oidc.') ||
        key.startsWith('0-') ||
        key.includes('token') ||
        key.includes('auth') ||
        key.includes('authnResult') ||
        key.includes('authWellKnownEndPoints') ||
        key.includes('userData') ||
        key.includes('authStateControl') ||
        key.includes('storageSilentRenewRunning')
      ) {
        console.log('Removing from sessionStorage:', key);
        sessionStorage.removeItem(key);
      }
    });

    // Supprimer l'email utilisateur du sessionStorage
    window.sessionStorage.removeItem('user_mail');
    console.log('Removed user_mail from sessionStorage');
  }

  /**
   * Supprime les cookies liés à l'authentification
   */
  public clearAuthCookies(): void {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      const cookieName = cookie.split('=')[0];

      // Supprimer les cookies liés à l'authentification
      if (
        cookieName.includes('auth') ||
        cookieName.includes('token') ||
        cookieName.includes('oidc')
      ) {
        console.log('Removing cookie:', cookieName);
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    }
  }

  /**
   * Effectue une déconnexion forcée et redirige vers la page de login
   */
  public forceLogoutAndRedirect(): void {
    this.cleanupSession();

    // Rediriger vers la page de login
    this.router.navigate(['/login']);

    // Forcer un rechargement de la page après un court délai
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }
}
